import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { supabase } from "../../supabase";
import Flower from "../../components/common/Flower/Flower";
import ClickFlower from "../../components/common/ClickFlower/ClickFlower";
import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader"
import { HowWordsCheck } from "../../functions/getStreak";
import { Link } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";



export default function OnlineCalculator(){
const [ResultWords, setResult] = useState();
const { id } = useParams(); 
const [project, setProject] = useState(null);

const today = new Date().toISOString().split("T")[0];

useEffect(() => {
    async function fetchProject() {
      const { data, error } = await supabase
        .from("projects")
        .select("*")
        .eq("id", id)
        .single();

      if (error) {
        console.error(error);
        return;
      }
      setProject(data);
    }

    fetchProject();
}, [id]);



    return (
        <div className="projectlist-wrapper">
                    <ProjectHeader
                        headerTitle={'Kalkulator'}
                        showBackButton={true}
                        path={`/online/project/${id}`}
                    />
        
                    <div className="SettingsForm" style={{marginTop: '100px'}}>
                        <form onSubmit={(e) =>{
                            e.preventDefault();
                            const result = HowWordsCheck(e, project);
                            setResult(result);
                        }}> 
                            <label>
                                Kiedy chcesz skończyć projekt
                                <input type = "date" name = "finishDate" className="chapterInput"/> 
                            </label>
                                <br/>
                            <div className="buttons-row">
                                    <button> Ile słów muszę pisać? </button>
                            </div>
                                <h6>Musisz pisać: {ResultWords}</h6>
                        </form>
                    </div>
                
                <Link to={`/online/project/${id}`} className="BackfixButton"><IoIosArrowBack /></Link>
        
                <Flower
                  flowerClass={"flower1"}/>
                <Flower
                  flowerClass={"flower2"}/>
                <ClickFlower/>
                </div>
    )
}